import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@3.12.2_@opentelemetry+api@1.9.0_eslint@9.5.0_rollup@2.79.1_typescript@5.5.2_vite@5.3.1_vue-tsc@2.0.22/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}